import { makeStyles, useTheme } from "@mui/styles";
import { AppBar, Tabs, Tab } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    paddingBottom: theme.spacing(2),
  },
  appBar: {
    backgroundColor: theme.palette.grey["100"],
  },
  tab: {
    padding: theme.spacing(2, 4),
    fontWeight: "700",
  },
}));
function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

const HorizontalGridList = ({ subLink, setSubLink, sources }) => {
  let theme = useTheme();
  const classes = useStyles(theme);

  const handleChange = (event, newValue) => {
    setSubLink(newValue);
  };
  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Tabs
          value={subLink}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          indicatorColor="primary"
          textColor="primary"
          aria-label="scrollable force tabs example"
        >
          {sources.map((source, index) => {
            return (
              <Tab
                label={source.name}
                key={index}
                className={classes.tab}
                {...a11yProps(index)}
              />
            );
          })}
        </Tabs>
      </AppBar>
    </div>
  );
};

export default HorizontalGridList;
